import React, { useRef, useEffect, useCallback, useState} from 'react';
import {useConsumeWheel} from "components/hooks/useConsumeWheel.js"
import {connect} from 'react-redux';
import EffectChooser from "components/effects/EffectChooser.js";

const FormantEffect = ({formant, sequencerEngine, track}) => { 
    let ref = useRef();
    let [effect, setEffect] = useState(formant.effect);

    useConsumeWheel(ref);

    useEffect(() => {
        if (formant) {
            setEffect(formant.effect);
        }
    }, [formant]);

    const onChange = useCallback((effect) => {
        formant.useEffect(effect);
        setEffect(effect);
    }, [setEffect, formant]);

    const onDelete = useCallback(() => {
        setEffect(undefined);
        formant.bypassEffect();
    }, [effect, setEffect, formant]);

    return (
        <div
          onDragStart={e => {
              e.stopPropagation();
              e.preventDefault();
          }}
          ref={ref} className="formant-effect">
          <div className="sub-header">Formant {formant.number + 1} FX</div>
          <EffectChooser
            track={track}
            sequencerEngine={sequencerEngine}
            onDelete={onDelete}
            noSelect={true}
            effect={effect}
            onChange={onChange}/>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FormantEffect);
